import React, { useEffect, useRef, useState } from 'react';

import { ZERO } from '~/src/features/movix-new/constants';
import { isChromium, isSafari } from '~/src/features/movix-new/utils';

import * as ST from './styled';

interface IProps {
    readyPlayVideo: boolean,
}

const VideoBlock: ({ readyPlayVideo }: IProps) => JSX.Element = (): JSX.Element => {
    const videoParentRef = useRef() as React.MutableRefObject<HTMLDivElement>;
    const [shouldUseImage, setShouldUseImage] = useState<boolean>(false);
    const [isChromiumState, setIsChromium] = useState<boolean>(false);
    useEffect(() => {
        setIsChromium(isChromium());
        if (isSafari() && videoParentRef.current) {
            const player = videoParentRef.current.children[ZERO] as HTMLVideoElement;
            if (player) {
                // @ts-ignore
                player.playsinline = true;
                player.muted = true;
                player.setAttribute('muted', '');
                player.autoplay = true;
                player.poster = '/static/images/movix-new/video.png';

                setTimeout(() => {
                    const promise = player.play();
                    if (promise.then) {
                        promise
                            .then()
                            .catch(() => {
                                videoParentRef.current.style.display = 'none';
                                setShouldUseImage(true);
                            });
                    }
                }, ZERO);
            }
        }
    }, []);

    return shouldUseImage
        ? <ST.VideoWrap><img src={'/static/images/movix-new/screen-tv.jpg'} alt='Video'/></ST.VideoWrap>
        : <ST.VideoWrap
            isChromium={isChromiumState}
            ref={videoParentRef}
            dangerouslySetInnerHTML={{
                __html: `
                    <video id="video" loop autoPlay muted playsInline poster='/static/images/movix-new/video.png' disablePictureInPicture>
                        <source src='/static/images/movix-new/video.mp4' type='video/mp4'/>
                    </video>
                `,
            }}
        />;
};

export default VideoBlock;

